import { Check } from "lucide-react";
import { Reveal, GoldBtn, PageHero, Particles } from "@/components/Shared";
import { ZONES } from "@/data/content";

export default function Zones() {
    return (
        <div data-testid="zones-page">
            <PageHero
                testid="zones-hero"
                eyebrow="Special Zones"
                title={<>Five Worlds Inside <span className="gold-text">the Bazaar</span></>}
                sub="Dedicated zones with their own character — international streets, arenas, pavilions and hubs — all within the MahaBazaar universe."
            />

            <section className="py-16 md:py-24">
                <div className="container-x space-y-8">
                    {ZONES.map((z, i) => (
                        <Reveal key={z.name}>
                            <div className={`card-luxe overflow-hidden grid lg:grid-cols-[1fr_1.3fr] ${i % 2 ? "lg:[direction:rtl]" : ""}`} data-testid={`zone-section-${i}`}>
                                <div className="relative min-h-56 lg:min-h-full overflow-hidden" style={{ background: `linear-gradient(150deg, ${z.tint}22, #1E060C 70%)`, direction: "ltr" }}>
                                    <div className="absolute inset-0 jaali opacity-40" />
                                    <Particles density={12} />
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <div className="w-28 h-36 arch-top border flex items-center justify-center" style={{ borderColor: `${z.tint}88` }}>
                                            <z.icon size={42} strokeWidth={1} style={{ color: z.tint }} />
                                        </div>
                                    </div>
                                    <span className="absolute top-6 left-6 font-display text-5xl" style={{ color: `${z.tint}55` }}>0{i + 1}</span>
                                </div>
                                <div className="p-8 md:p-12" style={{ direction: "ltr" }}>
                                    <span className="eyebrow no-lines" style={{ color: z.tint }}>Zone 0{i + 1}</span>
                                    <h2 className="font-display text-3xl md:text-4xl mt-4 text-[var(--ivory)]">{z.name}</h2>
                                    <p className="mt-5 text-muted-luxe text-base leading-relaxed">{z.desc}</p>
                                    <ul className="mt-7 space-y-3">
                                        {z.points.map((p) => (
                                            <li key={p} className="flex items-center gap-3 text-sm text-[var(--ivory)]/85">
                                                <Check size={14} strokeWidth={2} style={{ color: z.tint }} /> {p}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="mt-9">
                                        <GoldBtn to="/register" variant="outline" testid={`zone-register-${i}`}>Experience This Zone</GoldBtn>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>
        </div>
    );
}
